import * as React from 'react';
const SvgRetroTv = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={240}
    height={240}
    fill="none"
    viewBox="0 0 240 240"
    {...props}
  >
    <path
      fill="#E9F2FF"
      d="M120 204c46.39 0 84-37.61 84-84s-37.61-84-84-84-84 37.61-84 84 37.61 84 84 84"
    />
    <path
      fill="#CDF"
      fillRule="evenodd"
      d="M51.95 19.35a1.9 1.9 0 1 0 .002-3.798 1.9 1.9 0 0 0-.002 3.798m0 2.6c2.49 0 4.5-2.01 4.5-4.5s-2.01-4.5-4.5-4.5-4.5 2.01-4.5 4.5 2.01 4.5 4.5 4.5"
      clipRule="evenodd"
    />
    <path
      fill="#59F"
      d="M195.46 43.52c.51-2.09 3.48-2.09 3.98 0l.76 3.17c.18.75.76 1.33 1.51 1.51l3.17.76c2.09.5 2.09 3.48 0 3.98l-3.17.76c-.75.18-1.33.76-1.51 1.51l-.76 3.17c-.51 2.09-3.48 2.09-3.98 0l-.76-3.17c-.18-.75-.76-1.33-1.51-1.51l-3.17-.76c-2.09-.5-2.09-3.48 0-3.98l3.17-.76c.75-.18 1.33-.76 1.51-1.51zM64.35 210.61c.53-2.21 3.67-2.21 4.21 0l.71 2.94c.19.79.81 1.41 1.6 1.6l2.93.71c2.21.53 2.21 3.68 0 4.21l-2.93.71c-.79.19-1.41.81-1.6 1.6l-.71 2.94c-.53 2.21-3.67 2.21-4.21 0l-.71-2.94a2.17 2.17 0 0 0-1.6-1.6l-2.93-.71c-2.21-.53-2.21-3.68 0-4.21l2.93-.71a2.17 2.17 0 0 0 1.6-1.6zM69.52 41.62c1.37-.24 2.48 1.09 2 2.39l-2.62 7.15c-.48 1.3-2.18 1.6-3.07.54l-4.9-5.84c-.89-1.06-.3-2.69 1.07-2.92l7.51-1.31zM110.52 195.62c1.37-.24 2.48 1.09 2 2.39l-2.62 7.15c-.48 1.3-2.18 1.6-3.07.54l-4.9-5.84c-.89-1.06-.3-2.69 1.07-2.92l7.51-1.31z"
    />
    <path
      fill="#137"
      d="M120 91.63c12.465 0 22.57-7.58 22.57-16.93S132.465 57.77 120 57.77 97.43 65.35 97.43 74.7 107.535 91.63 120 91.63"
    />
    <path
      fill="#59F"
      d="M174.59 65.37H65.41C51.929 65.37 41 76.299 41 89.78v69.17c0 13.481 10.929 24.41 24.41 24.41h109.18c13.481 0 24.41-10.929 24.41-24.41V89.78c0-13.481-10.929-24.41-24.41-24.41"
    />
    <path
      fill="#05C"
      d="M179.25 99.22a5.98 5.98 0 1 0 0-11.96 5.98 5.98 0 0 0 0 11.96M179.25 120.77a5.98 5.98 0 1 0 0-11.96 5.98 5.98 0 1 0 0 11.96"
    />
    <path
      stroke="#137"
      strokeMiterlimit={10}
      strokeWidth={1.6}
      d="M112.59 59.39 81.46 28.27"
    />
    <path
      fill="#137"
      d="M81.06 31.82a3.95 3.95 0 1 0 0-7.9 3.95 3.95 0 0 0 0 7.9"
    />
    <path
      stroke="#137"
      strokeMiterlimit={10}
      strokeWidth={1.6}
      d="m127.41 59.39 31.13-31.12"
    />
    <path
      fill="#137"
      d="M158.94 31.82a3.95 3.95 0 1 0 0-7.9 3.95 3.95 0 0 0 0 7.9"
    />
    <mask
      id="a"
      width={105}
      height={91}
      x={55}
      y={79}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <path
        fill="#fff"
        d="M143.68 79.67h-72.5c-8.737 0-15.82 7.083-15.82 15.82v57.75c0 8.737 7.083 15.82 15.82 15.82h72.5c8.737 0 15.82-7.083 15.82-15.82V95.49c0-8.737-7.083-15.82-15.82-15.82"
      />
    </mask>
    <g mask="url(#a)">
      <path fill="#05C" d="M70.24 79.67H55.36v89.39h14.88z" />
      <path fill="#16E" d="M85.12 79.67H70.24v89.39h14.88z" />
      <path
        fill="#CDF"
        d="M100 79.67H85.12v89.39H100zM144.63 79.67h-14.88v89.39h14.88z"
      />
      <path fill="#05C" d="M114.87 79.67H99.99v89.39h14.88z" />
      <path fill="#16E" d="M129.75 79.67h-14.88v89.39h14.88z" />
      <path fill="#05C" d="M159.5 79.67h-14.88v89.39h14.88z" />
    </g>
    <path
      fill="#8BF"
      fillRule="evenodd"
      d="M169.03 209.46a1.9 1.9 0 1 0 .002-3.798 1.9 1.9 0 0 0-.002 3.798m0 2.6c2.49 0 4.5-2.01 4.5-4.5s-2.01-4.5-4.5-4.5-4.5 2.01-4.5 4.5 2.01 4.5 4.5 4.5"
      clipRule="evenodd"
    />
    <path
      fill="#CDF"
      d="M228 165.15c0 2.34-.85 4.6-2.39 6.36a9.68 9.68 0 0 1-6 3.21c-.42.05-.85.08-1.28.08h-32.16c-.7 0-1.39-.06-2.08-.17-2.96-.51-5.62-2.09-7.48-4.45a12.08 12.08 0 0 1-2.58-8.3c.19-2.99 1.49-5.8 3.63-7.9 2.15-2.09 4.99-3.32 7.99-3.45 1.55-3.37 4.16-6.14 7.43-7.9s7.02-2.41 10.69-1.85 7.06 2.29 9.66 4.94 4.26 6.07 4.74 9.75h.15c1.27 0 2.53.25 3.71.73 1.17.48 2.24 1.2 3.14 2.09.9.9 1.61 1.96 2.1 3.13s.74 2.43.74 3.7zM12.73 73.99c0 3.42 2.18 6.61 5.76 7.71.72.22 1.49.3 2.24.3h26.49c2.61-.01 5.11-1.05 6.98-2.89 1.86-1.84 2.93-4.33 2.99-6.95.05-2.62-.91-5.16-2.69-7.07a10 10 0 0 0-6.85-3.18 14.2 14.2 0 0 0-6.13-6.52 14.08 14.08 0 0 0-8.8-1.52c-3.02.46-5.81 1.89-7.95 4.08A14.16 14.16 0 0 0 20.85 66h-.13c-.74 0-1.48.07-2.18.29-3.6 1.09-5.79 4.28-5.8 7.7zM19 188.46c0 2.05.74 4.04 2.08 5.58a8.4 8.4 0 0 0 5.22 2.81c.37.05.74.08 1.11.08h27.96c.61 0 1.22-.05 1.82-.15 2.58-.43 4.92-1.82 6.55-3.89a10.7 10.7 0 0 0-.92-14.26 10.5 10.5 0 0 0-6.99-3 14.95 14.95 0 0 0-6.46-6.92c-2.84-1.54-6.1-2.11-9.3-1.62-3.19.49-6.14 2.01-8.4 4.33a15.03 15.03 0 0 0-4.13 8.55h-.13c-1.11 0-2.2.22-3.22.65a8.43 8.43 0 0 0-4.55 4.59 8.6 8.6 0 0 0-.64 3.25"
    />
  </svg>
);
export default SvgRetroTv;
